"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.16,15,14,13.64V8a2,2,0,0,0-4,0v9.4c-1.47-2-2.44-2.4-3.5-2.4-1.39,0-1.64,1.68-.92,2.78l4,6A.51.51,0,0,0,10,24h8a.49.49,0,0,0,.49-.41l1-5.48C19.76,16.92,19.46,15.44,18.16,15Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,0H8A4,4,0,0,0,4,4V9.5a4,4,0,0,0,4,4h.5a1,1,0,0,0,0-2H8a2,2,0,0,1-2-2V4A2,2,0,0,1,8,2h8a2,2,0,0,1,2,2V9.5a2,2,0,0,1-2,2h-.5a1,1,0,0,0,0,2H16a4,4,0,0,0,4-4V4A4,4,0,0,0,16,0Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;